(() => {
  const panelSelector = '[data-rvp-unified-panel="faq"]';

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const summary = event.target.closest(`${panelSelector} > details > summary`);
    if (!summary) return;

    const current = summary.parentElement;
    const panel = current?.closest(panelSelector);
    if (!panel || current.open) return;

    panel.querySelectorAll('details[open]').forEach((item) => {
      if (item !== current) item.open = false;
    });
  });
})();
